import { Autorenew } from '@material-ui/icons'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { SetWorkingModeDialog } from '../DoorDialogs'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { DoorDto } from '../../../../core/dto/device/doors/door.dto'
import { DoorWorkingModes } from '../../../../core/enum/DoorWorkingModes'
import { DoorWorkingModeById } from '../../../../core/devices/doors/doors.utils'

export const DoorSetWorkingModeButton = ({ ...props }) => {
  const { asRecurringJob, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const { record: door, refetch } = useShowContext<DoorDto>()
  const jsonStatus = JSON.parse(door?.jsonStatus || '{}')
  const [stateDialogOpen, setStateDialogOpen] = useState(false)
  const [workingMode, setWorkingMode] = useState<DoorWorkingModes | undefined>(
    undefined,
  )
  const [mutate, { loading: mutationLoading }] = useMutation()

  const handleSetWorkingMode = async (
    recurringJobName?: string,
    cronExpression?: string,
  ) => {
    await mutate(
      {
        type: sanitizeFetchType('setDoorWorkingMode'),
        resource: ResourceName.DOORS,
        payload: {
          doorId: door?.id,
          workingMode,
          recurringJobName,
          cronExpression,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    refetch?.()
  }

  const handleCloseDialog = () => {
    setStateDialogOpen(false)
    setWorkingMode(undefined)
  }

  const handleOpenDialog = () => {
    setWorkingMode(DoorWorkingModeById[jsonStatus?.WorkingMode as number])
    setStateDialogOpen(true)
  }

  return (
    <>
      <SetWorkingModeDialog
        open={stateDialogOpen}
        close={handleCloseDialog}
        workingMode={workingMode}
        setWorkingMode={setWorkingMode}
        handleSetWorkingMode={handleSetWorkingMode}
        asRecurringJob={asRecurringJob}
        door={door}
      />
      <Button
        variant="contained"
        color="primary"
        label={
          !asRecurringJob
            ? 'resources.doors.actions.setWorkingMode'
            : 'common.recurring-job.buttons.create-recurring-job'
        }
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DOORS_SET_RELEASE) ||
          loading ||
          mutationLoading
        }
        onClick={handleOpenDialog}
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
